type EstimationScatterDotProps = {
  cx: number;
  cy: number;
  fill: string;
  stroke: string;
  innerRadius: number;
  gap: number;
  strokeWidth: number;
};

export function EstimationScatterDot({
  cx,
  cy,
  fill,
  stroke,
  innerRadius,
  gap,
  strokeWidth,
}: EstimationScatterDotProps) {
  const ringRadius = innerRadius + gap + strokeWidth / 2;

  return (
    <g>
      <circle cx={cx} cy={cy} r={innerRadius} fill={fill} />
      <circle
        cx={cx}
        cy={cy}
        r={ringRadius}
        fill="none"
        stroke={stroke}
        strokeWidth={strokeWidth}
      />
    </g>
  );
}
